<h3>AVI Invoices</h3>
<p-table #invTable [value]="invoices">
    <ng-template pTemplate="header">
        <tr>
            <th>
                <span>ID</span>
            </th>
            <th>
                <span>Number</span>
            </th>
            <th>
                <span>Date</span>
            </th>
            <th>
                <span>Amount</span>
            </th>
            <th>
                <span>Created by</span>
            </th>
            <th>
                <span>
                    Download
                </span>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
        <tr>
            <td>
                <span>{{invoice.id}}</span>
            </td>
            <td>
                <span>Facture N°{{invoice.invoiceNumberStr}}</span>
            </td>
            <td>
                {{invoice.date | date: 'dd/MM/yyyy'}}
            </td>
            <td>
                {{invoice.totalDue}} €
            </td>
            <td>
                {{invoice.createdBy}}
            </td>
            <td>
                <p-button icon="pi pi-file-pdf" (onClick)="downloadPdf(invoice)"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>